var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDownOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.667 17.5L12.0503 17.1083C12.1579 17.0007 12.258 16.8878 12.351 16.7698C12.5173 16.5589 12.6607 16.3322 12.7837 16.0917C12.867 15.925 12.892 15.725 12.8503 15.5417L12.0837 11.6667H16.667C17.5837 11.6667 18.3337 10.9167 18.3337 10V9.1C18.3337 8.86667 18.2837 8.64167 18.192 8.43333L15.967 3.30833C15.667 2.80833 15.1253 2.5 14.5337 2.5H7.78366C6.9891 2.5 6.30381 2.97801 6.00033 3.66149C5.89321 3.90272 5.83366 4.16956 5.83366 4.45V10.975C5.83366 11.1321 5.8558 11.2871 5.89857 11.4358C5.97607 11.7053 6.12129 11.9543 6.32533 12.1583L11.667 17.5ZM11.6373 16.0561L7.03243 11.4512C6.90305 11.3218 6.83366 11.1511 6.83366 10.975V4.45C6.83366 3.92729 7.26094 3.5 7.78366 3.5H14.5337C14.7572 3.5 14.9588 3.60713 15.0817 3.78034L17.2767 8.83608C17.315 8.92313 17.3337 9.01137 17.3337 9.1V10C17.3337 10.3644 17.0314 10.6667 16.667 10.6667H10.8664L11.8616 15.6969C11.7937 15.8235 11.719 15.9432 11.6373 16.0561ZM4.85396 11.3036C4.70338 11.5225 4.45121 11.6667 4.16699 11.6667H1.66699V2.5H4.16699C4.62533 2.5 5.00033 2.875 5.00033 3.33333V10.8333C5.00033 10.8816 4.99617 10.9289 4.98819 10.975C4.9674 11.0952 4.92064 11.2067 4.85396 11.3036ZM2.66699 3.5H4.00033V10.6667H2.66699V3.5Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownOff);
export default __webpack_public_path__ + "static/media/ThumbsDownOff.8e8b2f4a1b66dcb50012f38c426ad851.svg";
export { ForwardRef as ReactComponent };